import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SeatStatus } from 'src/app/shared/models/team/seatStatus';

export interface SeatStatusEditData {
  currentStatus: string;
}

@Component({
  selector: 'app-seat-status-edit-modal',
  templateUrl: './seat-status-edit-modal.component.html',
  styleUrls: ['./seat-status-edit-modal.component.scss'],
  standalone: false
})
export class SeatStatusEditModalComponent {
  statuses = [
    { value: SeatStatus.Picked, label: 'Picked' },
    { value: SeatStatus.Invited, label: 'Invited' },
    { value: SeatStatus.NoResponse, label: 'No Response' },
    { value: SeatStatus.Accepted, label: 'Accepted' },
    { value: SeatStatus.Declined, label: 'Declined' },
    { value: SeatStatus.NoShow, label: 'No Show' }
  ];

  selectedStatus: SeatStatus;

  constructor(
    public dialogRef: MatDialogRef<SeatStatusEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SeatStatusEditData
  ) {
    this.selectedStatus = SeatStatus[
      data.currentStatus as keyof typeof SeatStatus
    ] as unknown as SeatStatus;
  }

  getStatusClass(label: string): string {
    return label.replace(' ', '');
  }

  isSelected(status: SeatStatus): boolean {
    return this.selectedStatus === status;
  }

  select(status: SeatStatus) {
    this.selectedStatus = status;
  }

  save() {
    this.dialogRef.close(this.selectedStatus);
  }
}
